"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const StageReviewDecisionOverrideMenuList = (props) => {
    const { dataOptions, onChangeOption } = props;
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default.customMenuList }, dataOptions === null || dataOptions === void 0 ? void 0 : dataOptions.map((option) => {
        return (react_1.default.createElement("div", { className: styles_modules_less_1.default['decision-option__root'], key: option.value },
            react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['decision-option__item']], label: option.label, icon: true, iconClasses: {
                    icon: [(0, clsx_1.default)(option.icon), styles_modules_less_1.default['decision-option__icon']],
                }, onClick: () => {
                    onChangeOption(option);
                } })));
    })));
};
exports.default = StageReviewDecisionOverrideMenuList;
